import { render, staticRenderFns } from "./ColumnStats.vue?vue&type=template&id=37469a84"
import script from "./ColumnStats.vue?vue&type=script&lang=js"
export * from "./ColumnStats.vue?vue&type=script&lang=js"
import style0 from "./ColumnStats.vue?vue&type=style&index=0&id=37469a84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports